export default "__VITE_ASSET__CAIRaRx3__"